export const KEYCODES = {
  ENTER: 13,
  SPACE: 32
};
